class SliderScrollable {
	constructor() {
		this.sliders = document.querySelectorAll(".slider-scrollable");

		if(!this.sliders) {
			return;
		}

		this.buildSliders();
	}

	buildSliders() {
		this.sliders.forEach(slider => {
			const slideImages = slider.querySelectorAll(".card-image img");
			const swiper = new Swiper(slider, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				spaceBetween: "4%",
				speed: 500,
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
					snapOnRelease: false,
				},
				on: {
					progress: (swiper, progress) => {
						slideImages.forEach(image => {
							gsap.to(image, {
								x: 9 * Math.min(Math.max(progress, 0), 1)+"%",
								duration: 0.2
							});
						});
					}
				}
			});
		});
	}
}